<template>
    <div class="expense-content">
        <div class="expense-box">
            <div class="expense-box-item">
                <div class="box-item-price"><VueCountUp :start-value="0" :end-value="baseCount.totalAmount" :duration="4" :decimals="0" :delay="1" /></div>
                <div class="box-item-text">总收益金额</div>
            </div>
            <div class="expense-box-item">
                <div class="box-item-price"><VueCountUp :start-value="0" :end-value="baseCount.drawAmount" :duration="4" :decimals="0" :delay="1" /></div>
                <div class="box-item-text">已提现收益</div>
            </div>
            <div class="expense-box-item">
                <div class="box-item-price"><VueCountUp :start-value="0" :end-value="baseCount.unDrawAmount" :duration="4" :decimals="0" :delay="1" /></div>
                <div class="box-item-text">可提现收益</div>
            </div>
            <div class="expense-box-item">
                <div class="box-item-price"><VueCountUp :start-value="0" :end-value="baseCount.onDrawAmount" :duration="4" :decimals="0" :delay="1" /></div>
                <div class="box-item-text">提现中收益</div>
            </div>
        </div>
        <el-card class="box-card mt20">
            <el-button type="primary" icon="el-icon-plus" @click="dialogChannelWithdrawVisible = true">添加 提现</el-button>
            <el-table
                :data="tableData"
                border
                class="mt20"
                :header-cell-style="{'text-align':'center'}"
                :cell-style="{'text-align':'center'}"
            >
                <el-table-column prop="insertTime" label="提现时间"></el-table-column>
                <el-table-column prop="drawBank" label="提现银行"></el-table-column>
                <el-table-column prop="drawAccount" label="银行账号"></el-table-column>
                <el-table-column prop="drawAmount" label="提现金额"></el-table-column>
                <el-table-column label="提现状态">
                    <template slot-scope="{row}">
                        <span v-if="row.drawState == 0" style="color: #ff4949;">提现中</span>
                        <span v-if="row.drawState == 1" style="color: #409eff;">已提现</span>
                    </template>
                </el-table-column>
                <el-table-column prop="completeDate" label="提现完成时间"></el-table-column>
                <el-table-column label="提现完成凭证">
                    <template slot-scope="{row}">
                        <span v-if="row.completeFile == null">未上传</span>
                        <el-image
                            v-else
                            style="height: 50px;width:50px;"
                            :src="row.completeFile"
                        />
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination">
                <el-pagination
                    background
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="query.currentPage"
                    :page-sizes="[10, 20, 30, 40]"
                    :page-size="query.pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="query.total">
                </el-pagination>
            </div>
        </el-card>
        <el-dialog title="添加提现" :visible.sync="dialogChannelWithdrawVisible" width="500px">
            <el-form :model="formData" label-width="100px">
                <el-form-item label="提现金额">
                    <el-input v-model="formData.withdrawAmount" placeholder="请输入提现金额"></el-input>
                </el-form-item>
                <el-form-item label="提现银行">
                    <el-input v-model="formData.withdrawBank" placeholder="请输入提现银行"></el-input>
                </el-form-item>
                <el-form-item label="提现银行账号">
                    <el-input v-model="formData.withdrawBankAccount" placeholder="请输入提现银行账号"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogChannelWithdrawVisible = false">取 消</el-button>
                <el-button type="primary" @click="getSubmitData">提 交</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import {
    channelUserWithdrawBase,
    channelUserWithdrawAdd,
    channelUserWithdrawList,
} from '@/api/index'
export default {

    data() {
        return {
            baseCount:{},
            tableData:[],
            query:{
                currentPage:1,
                pageSize:10,
                total:0,
            },
            dialogChannelWithdrawVisible:false,
            formData:{
                withdrawAmount:'',//提现金额
                withdrawBank:'',//提现银行
                withdrawBankAccount:'',//提现银行账号
            },
        };
    },

    mounted() {
        this.getBaseCount();
        this.getListData();
    },

    methods: {
        async getBaseCount(){
            const res = await channelUserWithdrawBase()
            this.baseCount = res.data;
        },
       
        async getListData(){
            let data = {
                pageNum:this.query.currentPage,
                pageSize:this.query.pageSize,
            }
            const res = await channelUserWithdrawList(data)
            if(res.success){
                this.tableData = res.data.records
                this.query.total = res.data.total
            }
        },
        handleSizeChange(val) {
            this.query.pageSize = val;
            this.getListData();
        },
        handleCurrentChange(val) {
            this.query.currentPage = val;
            this.getListData();
        },
        getSubmitData(){
            let data = {
                drawAmount:this.formData.withdrawAmount,//提现金额
                drawBank:this.formData.withdrawBank,//提现银行
                drawAccount:this.formData.withdrawBankAccount,//提现银行账号
            }
            channelUserWithdrawAdd(data).then(res=>{
                if(res.data){
                    this.$message.success('提现申请成功');//提示消息
                    
                    this.getBaseCount();
                    this.getListData();
                    this.dialogChannelWithdrawVisible = false;
                    // this.$refs.demandFormRef.resetFields();//重置表单
                }else {
                    this.$message.error(res.message);
                }
            })
        },
    },
};
</script>

<style lang="scss" scoped>
.expense-content{
    width:100%;
    height:auto;
    min-height:calc(100vh - 200px);
    box-sizing: border-box;
	padding:20px 20px;
	background-color: #f9fafb;
}
.expense-box{
    width:100%;
    height:auto;
    min-height:150px;
    
    display:flex;
    justify-content: space-between;
    .expense-box-item{
        width:23%;
        height:150px;
        border-radius:5px;
        
        box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
        // text-align: center;
        display:flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        background-color: #fff;
        .box-item-price{
            font-size: 1.5rem;
            font-weight: 600;
            color: #106eea;
        }
        .box-item-text{
            font-size:1rem;
            margin-top:10px;
            color: #666;
        }
    }
}
.table-box{
    display:inline-block;
    margin-right:10px;
}
.card-title{
    display:inline-block;
    margin-right:10px;
    font-size:14px;
    line-height:40px;
}
.handle-input{
    width:240px;
}

</style>